<template>
    <b-card :title="title">
        <b-card-header>
            <b-row>
                <b-col md="12" cols="12" class="query-filter dd">
                    <b-form-select class="mt-3 form-control" id="input-order-item-type" v-model="filters.order_item_type_id"
                        :options="types" text-field="name" value-field="id">
                        <template #first>
                            <b-form-select-option :value="null">
                                {{ $translate('select_any_type') }}
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="12" class="mt-3 d-flex align-items-center search-field">
                    <div class="input-group mb-0">
                        <b-form-input class="form-control" type="text" :placeholder="$translate('search_master_items')"
                            v-model="query"></b-form-input>
                        <div class="input-group-prepend bg-transparent">
                            <i class="mdi mdi-magnify"></i>
                        </div>
                    </div>
                    <slot></slot>
                </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <b-col class="page-block"><strong>
                    {{ $translate('page') }}: {{ pagination.page }} {{ $translate('of') }} {{ pageCount }} {{
                        $translate('total') }}:
                    {{ pagination.total }}
                </strong>
            </b-col>
            <b-col class="overflow-auto w-100 mt-4">
                <b-table :fields="itemFields" striped hover responsive :items="items">
                    <template #cell(id)="row">
                        <b-button size="sm" @click="viewItem(row.item.id)" v-if="hasPermissionView" class="mr-2"
                            variant="pink-button">
                            <img src="@/assets/images/icon/view.svg" />
                        </b-button>
                    </template>
                </b-table>
            </b-col>
            <b-row>
                <b-col>
                    <b-pagination class="justify-content-center mt-4" v-model="pagination.page"
                        :total-rows="pagination.total" :per-page="pagination.pageSize" aria-controls="assetTable"
                        :prev-text="$translate('previous')" :next-text="$translate('next')" pills
                        align="center"></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import _ from 'lodash'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'MasterItems-ListItems',
    props: ['type', 'title'],
    mixins: [popupMixins, permissionsMixins],

    data() {
        return {
            reportType: 'master_item_details',
            filters: {
                order_item_type_id: null,
            },
            query: '',
        }
    },

    mounted() {
        console.log('items', this.items)
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },
    computed: {

        itemFields() {
            return [
                {
                    key: 'id',
                    label: this.$translate('actions'),
                    stickyColumn: true,
                },
                {
                    key: 'name',
                    label: this.$translate('name'),
                },
                {
                    key: 'ext_reference_code',
                    label: this.$translate('code'),
                },
                {
                    key: 'order_item_type_id',
                    label: this.$translate('type'),
                    formatter: (value, key, item) =>
                        item.type && item.type.name,
                },
                {
                    key: 'vendor_id',
                    label: this.$translate('vendor'),
                    formatter: (value, key, item) =>
                        item.vendor && item.vendor.name,
                },

                {
                    key: 'ext_reference_code',
                    label: this.$translate('code'),
                    formatter: (value, key, item) => item.ext_reference_code,
                },

                {
                    key: 'uom',
                    label: this.$translate('uom'),
                    formatter: (value, key, item) => item.uom,
                },
                {
                    key: 'selling_price',
                    label: this.$translate('price'),
                    formatter: (value, key, item) => item.selling_price,
                },
            ]
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        items() {
            const _items = this.$store.state.masterItem.items
            console.log('master items', _items)
            return _items
        },
        pagination() {
            return this.$store.state.masterItem.pagination || {}
        },

        types() {
            return this.$store.state.itemType.items.filter(x => !x.is_discount)
        },
    },
    watch: {
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        filters: {
            handler: function (filters) {
                console.log('filters', filters)
                this.doSearch()
            },
            deep: true,
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
        report_loading: function (val) {
            this.$emit('report-state', val)
        },
    },

    methods: {
        totalQty(item) {
            let _sum = 0
            item.sections.forEach(section => {
                _sum += section.quantity_on_hand
            })
            return _sum
        },
        getReportQuery() {
            const q = this.query
            return { q, ...this.filters }
        },
        viewItem(id) {
            const path = `${this.$route.path}/${id}`
            this.$router.push({ path })
        },

        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        doSearch() {
            let {
                query,
                pagination: { page },
                filters,
            } = this
            if (!parseInt(filters.order_item_type_id, 10)) {
                filters.order_item_type_id = null
            }
            this.$store.dispatch('masterItem/fetch', {
                query,
                page,
                filters,
            })
        },
        deleteItem(id) {
            let item = this.items.find(el => el.id == id)

            const title = this.$translate('delete_master_item_popup');
            const message = `${this.$translate('delete_note')} ${item.name}?`
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.$store
                        .dispatch('masterItem/delete', id)
                        .then(() => {
                            this.doToast(
                                this.$translate('deleted'),
                                this.$translate('item_delete_alert'),
                                'success'
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.doToast(
                                this.$translate('error'),
                                this.$translate('unable_alert'),
                                'danger'
                            )
                        })
                }
            })
        },
    },
}
</script>
<style></style>
